export const handleChangeDataModalRejectFactor = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_REJECT_FACTOR', name, value
});